import { request } from "../utils/netRequest";
import { getToken } from "../utils/token";

export class FlightService {
  async status(carrier, flight, year, month, day) {
    return await request({
      baseURL: ' https://flightstats-proxy.tecorien.com/',
      url: `/flex/flightstatus/rest/v2/json/flight/status/${carrier}/${flight}/arr/${year}/${month}/${day}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  };

}

export default new FlightService();


